<div class="search-container">
  <div class="search-rows">
    <div class="basic-search-row">
      <div class="search-input-container basic-search-input-container">
        <app-custom-search-input [showTipIcon]="true"
                                 (changedMap)="processFreeTextSearch($event)"
                                 (changedOperator)="processFreeTextSearch($event)"
                                 showQueryOperator="true"
                                 placeholder="Text Search..."></app-custom-search-input>
      </div>
      <div (click)="changeMode()">
        <button class="advanced-search-button" mat-button color="secondary">
          <span>{{isAdvancedSearchMode ? 'Basic search' : 'Advanced search'}}</span>
          <mat-icon *ngIf="!isAdvancedSearchMode" svgIcon="expand_more"></mat-icon>
          <mat-icon *ngIf="isAdvancedSearchMode" svgIcon="expand_less"></mat-icon>
        </button>
      </div>
    </div>
    <div class="advanced-search" *ngIf="isAdvancedSearchMode &&  formGroups.length > 0">
      <div class="search-row" *ngFor="let form of formGroups; let idx = index">
        <ng-container [formGroup]="form">
          <mat-form-field class="operator" appearance="outline">
            <mat-select formControlName="logicalOperator" (selectionChange)="processLogicalOperatorChanging(form, $event.value)">
              <mat-option *ngFor="let logicalOperator of logicalOperatorValues" [value]="logicalOperator" [selected]="logicalOperator == selectedLogicalOperatorsMap.get(idx)">
                {{logicalOperator}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="search-input-container">
            <mat-form-field class="w-220" appearance="outline">
              <mat-select formControlName="field" (selectionChange)="onSelectedSearchField(form)">
                <mat-option *ngFor="let searchField of criteriaOffer" [value]="fieldMap.get(searchField)">
                  {{'search_criteria.' + searchField | translate}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container (*ngFor="let control of form.controls" )>
              <app-custom-search-input *ngIf="form.controls['field'].value && form.value['filterType'] == 'TEXT'"
                                       style="width: 100%;"
                                       full-width
                                       showQueryOperator="true"
                                       [value]="form.value.values"
                                       [operator]="form.value.operator"
                                       placeholder="Name..."
                                       (changedMap)="processSearchValueMap(form, $event)"
                                       (changedOperator)="processSearchValueMap(form, $event)"></app-custom-search-input>
              <div *ngIf="form.controls['field'].value && form.value['filterType'] == 'DROPDOWN'"
                   class="multiselect-wrapper">
                <ng-multiselect-dropdown
                  [placeholder]="'Name'"
                  [settings]="dropdownSettings"
                  [ngModel]="selectedItemsMap.get(idx)"
                  [ngModelOptions]="{standalone: true}"
                  [data]="dropDownValuesMap.get(form.controls['field'].value)"
                  (onSelect)="onItemSelect(form, $event)"
                  (onDeSelect)="onItemDeSelect(form, $event)">
                </ng-multiselect-dropdown>
              </div>
              <button *ngIf="formGroups.length > 0 && form.controls['field'].value" mat-mini-fab
                      class="icon-button" (click)="removeField(idx)"
                      matTooltip="{{'remove_search_field' | translate}}"
                      matTooltipPosition="below"
                      matTooltipShowDelay="500">
                <mat-icon svgIcon="delete" class="icon"></mat-icon>
              </button>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
